import { ITeamSettings } from '@/entities/admin-app/commonSettings';

export enum HealthServiceType {
  Unknown = 0,
  MailService = 1,
  DocumentServer = 2,
  MailModule = 3,
  ContactsModule = 4,
  DiskModule = 5,
  DrawModule = 6,
  CalendarModule = 7,
  ProjectsModule = 8,
  LdapServer = 9
}

export enum UserAction {
  SuccessfulAuthorization = 260, // Успешная авторизация
  UnsuccessfulAttempt = 263, // Неудачная попытка
  Logout = 264, // Выход из системы
  DocumentCreation = 23, // Создание документа
  DocumentRemovalFromFolder = 180, // Удаление документа из папки
  DocumentRemovalFromTrash = 192, // Удаление документа из корзины
  DocumentRemovalFromGlobalTrash = 193, // Удаление документа из глобальной корзины
  CalendarDeletion = 19, // Удаление календаря
  ContactAddToFavorites = 27, // Добавление в избранное контакта
  DocumentAddToFavorites = 28, // Добавление в избранное документа
  LinkCreation = 25, // Создание ссылки
  ExternalLinkCreation = 26, // Создание внешней ссылки
  DocumentDownload = 120, // Скачивание документа
  DocumentUpload = 121, // Загрузка документа
  DocumentDownloadByLink = 124, // Скачивание документа по ссылке
  DocumentOpen = 125, // Открытие документа
  DocumentOpenByExternalLink = 126, // Открытие документа по внешней ссылке
  DocumentEditing = 127, // Редактирование документа
  EventAccessGrant = 130, // Предоставление доступа к событию
  CalendarAccessGrant = 131, // Предоставление доступа к календарю
  ProjectAccessGrant = 132, // Предоставление доступа к проекту
  FolderDeletion = 181, // Удаление папки
  EventDeletion = 184, // Удаление события
  DocumentListRetrieval = 41, // Получение списка документов
  FolderRestoration = 191, // Восстановление папки
  DocumentMove = 199, // Перемещение документа
  UserDeletion = 268, // Удаление пользователя
  UserDeletionWithDocumentTransfer = 269, // Удаление пользователя с переносом документов
  ChangeTokenDuration = 500,
  PasswordEnterCount = 501,
  AdminIpWhiteList = 502,
  UserIpWhiteList = 503,
  ChangeLdapSettings = 504
}

export enum LevelUserPriority {
  Emergency = 0, // Аварийная ситуация – система неработоспособна
  Alert = 1, // Требуется немедленное вмешательство
  Critical = 2, // Критическая ошибка
  Error = 3, // Ошибка, требующая исправления
  Warning = 4, // Предупреждение о возможной проблеме
  Notice = 5, // Информационное сообщение, не являющееся ошибкой
  Info = 6, // Обычная информационная запись
  Debug = 7 // Отладочные сообщения
}

export enum CommonSettingType {
  None = 0,
  Commands = 1,
  CommonViewSettings = 2,
  UserActionPriority = 3
}

export interface ICommonViewSettings {
  Name: string;
  MainLogoId: number;
  BrandColor: string;
  MainLogoUrl: string;
}

export interface UserActionPriority {
  Id: number;
  Type: UserAction;
  // Module: HealthServiceType;
  ModuleName: string;
  TypeName: string;
  Level: LevelUserPriority;
}

export interface CommonSettings {
  TeamSettings: ITeamSettings;
  CommonViewSettings: ICommonViewSettings;
  UserActionPriority: UserActionPriority[];
}

export type SaveSettingsParams = {
  Type: CommonSettingType;
  Data: Partial<CommonSettings>;
};
